// extracted by mini-css-extract-plugin
module.exports = {"TextSlider":"TextSlider_TextSlider__OdOy4"};